import { $cms } from "@/utils/api";

export function getMyFeedbacks(params) {
    return $cms().get(`/feedback/i`, { params });
}

export function getFeedback(id) {
    return $cms().get(`/feedback/${id}`);
}

export function getMyFeedbackLogs(params) {
    return $cms().get(`/feedback/log`, { params });
}

export function addFeedback(data) {
    return $cms().post(`/feedback`, data);
}

export function closeFeedbacks(data) {
    return $cms().put(`/feedback/close`, data);
}

// 补充
export function reply(data) {
    return $cms().post(`/feedback/reply`, data);
}

export function getReplies(params) {
    return $cms().get(`/feedback/reply`, { params });
}

export function deleteReply(id) {
    return $cms().delete(`/feedback/reply/${id}`);
}

// 获取用户反馈状态扩展
export function getMyFeedbackStatus() {
    return $cms({ mute: true }).get(`/feedback/extend`);
}

// 提交反馈状态
export function triggerFeedbackStatus() {
    return $cms().get(`/feedback/extend/trigger`);
}
